import becauseYouShopped from './becauseYouShopped';

export default becauseYouShopped;
